export const TERMS_OF_USE = 'WEB_TC';
export const WEB_PREFERENCE_CENTER = 'WEB_PREFERENCE_CENTER';
export const WEB_PRIVACY = 'WEB_PRIVACY';
export const WEB_TERMS_OF_USE = 'WEB_TERMS_OF_USE';
export const WEB_A_NOTICES = 'WEB_A_NOTICES';
export const WEB_INFORMATIONDATA = 'WEB_INFORMATIONDATA';
